import { postDataForSave } from "../request/apiManager";
import { BloodPressureRequestType } from "src/web/types";
import { DEFAULT_DISEASE_ID } from "src/web/constants";

export function saveBloodPressure(data: BloodPressureRequestType, diseaseId?: string) {
  const pathDiseaseId = diseaseId ?? DEFAULT_DISEASE_ID;
  return postDataForSave(`/api/v2/diseases/${pathDiseaseId}/blood-pressure`, data);
}
